module.exports = __webpack_public_path__ + "img/four.4c4cae1a.png";